import React from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/fontawesome-free-solid";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="col s12 l2 m2 valign-wrapper push-l10 push-m10" id="footer">
      <div id="footer-inner-wrapper" className="row">
        <Link to="/capture">
          <div className="btn-purple valign-wrapper share-photo-label">
            <div className="center-align w-100">
                <FontAwesomeIcon
                  icon={faCamera}
                />
                Share a Picture
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js